import PropTypes from 'prop-types';
import React from 'react';

import { slsPermissions } from '../../../utils/tab-permissions';
import { PageTemplate } from '../../reusable';

import Main from './Main';

const SLS = (props) => (
  <PageTemplate
    auth={slsPermissions}
    description="View and maintain store location media information."
    help={(
      <a
        className="ncss-cta-primary-dark underline text-color-secondary"
        href="https://confluence.nike.com/display/RCFITC/RCF+KB+-+SLS+UI"
        rel="noopener noreferrer"
        target="_blank"
      >
        Click here to view the KB
      </a>
    )}
    page={<Main />}
    path={props.location.pathname}
    title="Store Location Services Media"
  />
);

SLS.propTypes = {
  location: PropTypes.shape().isRequired,
};

export default SLS;
